import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { VehicleCategoryService } from '../proxy/general/controllers/vehicle-category.service';
import { SpeciesService } from '../proxy/general/controllers/species.service';

FieldBuilder.setNamespace('General');

export const SPECIESPERVEHICLECATEGORY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .number('quantity', 'Entity.SpeciesPerVehicleCategory.Quantity')
    .required()
    .decimal()
    .build(),
  FieldBuilder.foreignKey(
    'vehicleCategoryId',
    'Entity.VehicleCategory',
    VehicleCategoryService
  )
    .required()
    .displayFromNested('vehicleCategory.name')
    .sortBy('vehicleCategory.name')
    .build(),
  FieldBuilder.foreignKey(
    'speciesId',
    'Entity.Species',
    SpeciesService
  )
    .required()
    .displayFromNested('species.name')
    .sortBy('species.name')
    .build(),
];

export const SPECIESPERVEHICLECATEGORY_CONFIG = {
  entityName: 'SpeciesPerVehicleCategory',
  localizationKey: 'General::Entity.SpeciesPerVehicleCategory',
  fields: SPECIESPERVEHICLECATEGORY_FIELDS,
  permission: 'General.SpeciesPerVehicleCategories',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: undefined,
};
